import { styled } from '@mui/material/styles';
import { Box, AppBar as MuiAppBar } from '@mui/material';

export const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
  background: '#162a35',
  height: 48
}));

export const AppBarOffset = styled('div')(({ theme }) => ({
  ...theme.mixins.denseToolbar,
  minHeight: 48
}));

export const HeaderToolbar = styled(Box)({
  height: '100%',
  display: 'flex',
  alignItems: 'center'
});

export const Logo = styled('div')({
  height: 20,
  width: 59,
  backgroundImage: 'url(https://scenarioeditorstdev.blob.core.windows.net/public/white_logo.png)',
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  display: 'flex',
  alignItems: 'center'
});

export const BigLogo = styled('div')({
  height: 103,
  width: 285,
  marginRight: -25,
  backgroundImage: 'url(https://scenarioeditorstdev.blob.core.windows.net/public/sklls_logo.png)',
  backgroundPosition: 'center center',
  backgroundSize: 'cover'
});

export const HeaderToolbarLink = styled('a')({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  '&:visited, &:hover, &:active': {
    color: 'white',
    textDecoration: 'none'
  }
});

export const HeaderToolbarTitle = styled('span')({
  color: 'white',
  fontSize: 12,
  display: 'block'
});

export const TitleLogin = styled('span')({
  color: 'black',
  fontSize: 32,
  display: 'block'
});

export const TitleLoginGridItem = styled('div')({
  marginBottom: '50px'
});

export const IconIsleWidth = styled('div')({
  width: 276,
  height: '100%',
  display: 'flex',
  alignItems: 'center'
});

export const WhiteIcon = styled('div')({
  color: 'white'
});

export const SignOffBtn = styled('button')({
  color: 'white'
});

export const MaxWidth = styled('div')({
  maxWidth: 276,
  height: '100%',
  display: 'flex',
  alignItems: 'center'
});

export const HeaderToolsWidth = styled('div')({
  width: 'calc(100% - 276px)',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
});

export const CompanyNamePadding = styled('div')({
  padding: '6px 8px'
});

export const UserAvatar = styled('div')({
  height: 35,
  width: 35
});
